module.exports = __webpack_public_path__ + "9cdf53423b3e74483294df56ae76f6da.png";